import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { getFormattedTimezone } from '@recruitee/time';

import { ClipboardCopy } from '../../clipboard-copy.service';
import { AvatarComponent } from '../avatar/avatar.component';
import { ButtonComponent } from '../button/components/button/button.component';
import { IconButtonComponent } from '../button/components/icon-button/icon-button.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { RtTooltip } from '../tooltip/tooltip.directive';

type User = {
  firstName: string;
  lastName: string;
  roleName: string;
  email: string;
  phone: string;
  timezone: string;
  photoThumbUrl: string;
};

@Component({
  selector: 'rt-admin-details-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    DropdownComponent,
    IconButtonComponent,
    ButtonComponent,
    TranslatePipe,
    RtTooltip,
    AvatarComponent,
  ],
  templateUrl: './admin-details-dropdown.component.html',
  styleUrls: ['./admin-details-dropdown.component.less'],
})
export class AdminDetailsDropdownComponent {
  @Input() public admin?: User;

  public timezone = '';
  constructor(private copy: ClipboardCopy) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.admin?.currentValue) {
      this.timezone = getFormattedTimezone(this.admin?.timezone!);
    }
  }

  public copyEmail() {
    this.copy.fromString(this.admin?.email!);
  }
}
